import React, { lazy, Suspense } from 'react';
import LogoSpinner from 'src/component/UI/LogoSpinner';
import './Routes.scss';

const AlarmSimplificationScreen = lazy(() => import('src/screen/Protected/AlarmSimplificationScreen/AlarmSimplificationScreen'));

export default function AlarmSimplificationScreenRoute () {
  return (
    <div>
      <Suspense fallback={<div className='logo-spinner-centered'><LogoSpinner size={100}/></div>}>
        <AlarmSimplificationScreen />
      </Suspense>
    </div>
  );
}
